var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Modal, Button, TextArea, TextField, RadioButton, Checkbox, KeyValue, Row, Col, MessageBanner, ConfirmationModal, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { isSpecialKind } from "../../utils/issueKind";
import { ISSUE_LABEL_MAX_LENGTH, specialDerivationBase, } from "../../utils/issueLabel";
import { adjacentVolumes, errorParameterValues, } from "../../utils/volumeWindow";
import { MAX_ISSUE_NUMBER, isValidIssueNumber } from "../../utils/issueNumber";
import { crossVolumeMergeLabelValues, issueGroupMax, issueGroupNumbers, mergeLabelValues, } from "../../utils/mergeLabel";
import { changeIssueLibraryStatus, updateIssueGlobal, mergeIssues, unmergeIssue, updateMergeLabel, resetIssueLabel, createSpecialIssue, deletePeriodicalIssue, fetchVolumeMatrix, } from "../../api/periodicalIssueService";
import { ISSUE_MATRIX_KEY, invalidateVolumeViews, } from "../../hooks/usePeriodicalVolumes";
import { extractNumericPrefix } from "../../utils/extractNumericPrefix";
import { useIssueDateFormatter } from "../../hooks/useIssueDateFormatter";
import { suffixLetter } from "../../utils/suffixLetter";
import { RecordHistory } from "../enforcement/RecordHistory";
import { IssueAgendaSection } from "../agenda/IssueAgendaSection";
import { issueHandledInMonographs } from "../../utils/issueAgenda";
import { useIssueAgenda } from "../../hooks/useAgenda";
import { DepositRecordStatusBadge, LIBRARY_STATUS_BY_ACTION, LibraryStatusChoice, actionForStatus, isLibraryAction, } from "../enforcement/statusChoice";
import css from "./IssueStatusDialog.module.css";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
var canReceive = function (status) {
    return status === "CREATED" ||
        status === "OVERDUE" ||
        status === "DAMAGED" ||
        status === "DAMAGED_REPORTED";
};
var isCrossVolumeMergeable = function (issue) {
    return !isSpecialKind(issue.kind) &&
        !issue.notPublished &&
        !issue.continuesIntoNextVolume &&
        !issue.continuedFromPreviousVolume;
};
var CopyHistory = function (_a) {
    var recordId = _a.recordId, expanded = _a.expanded, onToggle = _a.onToggle;
    return (React.createElement("div", { className: css.historyBlock },
        React.createElement(Button, { onClick: onToggle(recordId), marginBottom0: true, buttonStyle: "default" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.action.history" })),
        expanded && React.createElement(RecordHistory, { recordId: recordId })));
};
export var IssueStatusDialog = function (_a) {
    var _b, _c, _d, _e, _f;
    var issue = _a.issue, allIssues = _a.allIssues, periodicalLibraryId = _a.periodicalLibraryId, subscribed = _a.subscribed, volume = _a.volume, volumes = _a.volumes, mode = _a.mode, numberEditable = _a.numberEditable, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    var issueAgendaQuery = useIssueAgenda(mode === "library" ? issue.id : null);
    var noRecordMessageId = !subscribed
        ? "ui-br-legaldeposits.periodicals.issue.dialog.not-tracked"
        : ((_b = issueAgendaQuery.data) === null || _b === void 0 ? void 0 : _b.agenda) === "MONOGRAPHS"
            ? "ui-br-legaldeposits.periodicals.issue.dialog.no-record.monographs"
            : "ui-br-legaldeposits.periodicals.issue.dialog.no-record";
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var statusReadOnly = mode === "library" && issueHandledInMonographs(issue);
    var formatIssueDate = useIssueDateFormatter();
    var issueDateText = formatIssueDate(issue.expectedDate);
    var issueHeading = issueDateText
        ? "".concat(issue.label, " \u2014 ").concat(issueDateText)
        : issue.label;
    var _g = useState(null), selectedAction = _g[0], setSelectedAction = _g[1];
    var _h = useState(""), note = _h[0], setNote = _h[1];
    var _j = useState(null), errorMessage = _j[0], setErrorMessage = _j[1];
    var _k = useState([]), mergeTargets = _k[0], setMergeTargets = _k[1];
    var _l = useState(false), crossVolumeSelected = _l[0], setCrossVolumeSelected = _l[1];
    var _m = useState(""), mergeLabel = _m[0], setMergeLabel = _m[1];
    var _o = useState(""), specialLabel = _o[0], setSpecialLabel = _o[1];
    var _p = useState(""), specialNote = _p[0], setSpecialNote = _p[1];
    var _q = useState(""), editLabel = _q[0], setEditLabel = _q[1];
    var _r = useState(""), editNote = _r[0], setEditNote = _r[1];
    var _s = useState(""), editMergeLabel = _s[0], setEditMergeLabel = _s[1];
    var _t = useState(""), editIssueNumber = _t[0], setEditIssueNumber = _t[1];
    var _u = useState(false), deleteConfirmOpen = _u[0], setDeleteConfirmOpen = _u[1];
    var _v = useState(false), renumberFollowing = _v[0], setRenumberFollowing = _v[1];
    var _w = useState({}), copyActions = _w[0], setCopyActions = _w[1];
    var _x = useState(new Set()), expandedHistory = _x[0], setExpandedHistory = _x[1];
    var isMultiIssue = useMemo(function () { var _a, _b; return ((_b = (_a = issue.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1; }, [issue.mergedIssueNumbers]);
    var copyNumbers = useMemo(function () {
        return issue.copyStatuses
            ? Object.keys(issue.copyStatuses)
                .map(Number)
                .sort(function (a, b) { return a - b; })
            : [];
    }, [issue.copyStatuses]);
    var isMultiCopy = useMemo(function () {
        var _a;
        return mode === "library" &&
            ((_a = issue.copyCount) !== null && _a !== void 0 ? _a : 1) > 1 &&
            copyNumbers.length > 1;
    }, [mode, issue.copyCount, copyNumbers.length]);
    var hasCopyAction = useMemo(function () {
        return copyNumbers.some(function (cn) {
            var _a;
            var selected = copyActions[cn];
            return (selected != null &&
                selected !== actionForStatus((_a = issue.copyStatuses) === null || _a === void 0 ? void 0 : _a[cn]));
        });
    }, [copyNumbers, copyActions, issue.copyStatuses]);
    var libraryCurrentAction = useMemo(function () { return actionForStatus(issue.libraryStatus); }, [issue.libraryStatus]);
    var eligibleForMerge = useMemo(function () {
        if (isMultiIssue)
            return [];
        return allIssues.filter(function (other) {
            var _a, _b;
            if (other.id === issue.id)
                return false;
            if (isSpecialKind(other.kind))
                return false;
            if (other.notPublished)
                return false;
            if (other.continuedFromPreviousVolume)
                return false;
            if (((_b = (_a = other.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1)
                return false;
            var diff = Math.abs(other.issueNumber - issue.issueNumber);
            return diff >= 1 && diff <= 3;
        });
    }, [allIssues, issue, isMultiIssue]);
    var neighbourVolumes = useMemo(function () { return adjacentVolumes(volumes, volume.id); }, [volumes, volume.id]);
    var nonSpecialVolumeRows = useMemo(function () { return allIssues.filter(function (row) { return !isSpecialKind(row.kind); }); }, [allIssues]);
    var offerNextVolumeCandidate = useMemo(function () {
        return mode === "definition" &&
            !!neighbourVolumes.next &&
            isCrossVolumeMergeable(issue) &&
            nonSpecialVolumeRows.length > 0 &&
            issueGroupMax(issue) === Math.max.apply(Math, nonSpecialVolumeRows.map(issueGroupMax));
    }, [mode, neighbourVolumes.next, issue, nonSpecialVolumeRows]);
    var offerPrevVolumeCandidate = useMemo(function () {
        return mode === "definition" &&
            !!neighbourVolumes.previous &&
            isCrossVolumeMergeable(issue) &&
            !isMultiIssue &&
            nonSpecialVolumeRows.length > 0 &&
            issue.issueNumber === Math.min.apply(Math, nonSpecialVolumeRows.map(function (row) { return row.issueNumber; }));
    }, [
        mode,
        neighbourVolumes.previous,
        issue,
        isMultiIssue,
        nonSpecialVolumeRows,
    ]);
    var nextVolumeId = (_c = neighbourVolumes.next) === null || _c === void 0 ? void 0 : _c.id;
    var prevVolumeId = (_d = neighbourVolumes.previous) === null || _d === void 0 ? void 0 : _d.id;
    var nextVolumeMatrix = useQuery([ISSUE_MATRIX_KEY, periodicalLibraryId, nextVolumeId], function () {
        return fetchVolumeMatrix(kyInstance, periodicalLibraryId, nextVolumeId);
    }, { enabled: offerNextVolumeCandidate && !!nextVolumeId }).data;
    var prevVolumeMatrix = useQuery([ISSUE_MATRIX_KEY, periodicalLibraryId, prevVolumeId], function () {
        return fetchVolumeMatrix(kyInstance, periodicalLibraryId, prevVolumeId);
    }, { enabled: offerPrevVolumeCandidate && !!prevVolumeId }).data;
    var nextVolumeCandidate = useMemo(function () {
        var _a, _b;
        if (!offerNextVolumeCandidate || !nextVolumeMatrix)
            return null;
        var rows = nextVolumeMatrix.issues.filter(function (row) { return !isSpecialKind(row.kind); });
        if (rows.length === 0)
            return null;
        var first = rows.reduce(function (min, row) {
            return row.issueNumber < min.issueNumber ? row : min;
        });
        var mergeable = isCrossVolumeMergeable(first) && !((_b = (_a = first.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
        return mergeable ? first : null;
    }, [offerNextVolumeCandidate, nextVolumeMatrix]);
    var prevVolumeCandidate = useMemo(function () {
        if (!offerPrevVolumeCandidate || !prevVolumeMatrix)
            return null;
        var rows = prevVolumeMatrix.issues.filter(function (row) { return !isSpecialKind(row.kind) && !row.continuedFromPreviousVolume; });
        if (rows.length === 0)
            return null;
        var last = rows.reduce(function (max, row) {
            return issueGroupMax(row) > issueGroupMax(max) ? row : max;
        });
        return isCrossVolumeMergeable(last) ? last : null;
    }, [offerPrevVolumeCandidate, prevVolumeMatrix]);
    var crossVolumeCandidate = nextVolumeCandidate !== null && nextVolumeCandidate !== void 0 ? nextVolumeCandidate : prevVolumeCandidate;
    var crossVolume = nextVolumeCandidate
        ? neighbourVolumes.next
        : neighbourVolumes.previous;
    var siblingsCount = useMemo(function () { return allIssues.filter(function (i) { return i.parentIssueId === issue.id; }).length; }, [allIssues, issue.id]);
    var defaultSpecialLabel = useMemo(function () {
        return "".concat(extractNumericPrefix(specialDerivationBase(issue))).concat(suffixLetter(siblingsCount + 1));
    }, [issue, siblingsCount]);
    useEffect(function () {
        setSelectedAction(null);
        setNote("");
        setMergeTargets([]);
        setCrossVolumeSelected(false);
        setMergeLabel("");
        setSpecialLabel("");
        setSpecialNote("");
        setEditLabel("");
        setEditNote("");
        setEditMergeLabel("");
        setDeleteConfirmOpen(false);
        setErrorMessage(null);
        setCopyActions({});
        setExpandedHistory(new Set());
    }, [issue]);
    useEffect(function () {
        if (selectedAction === "addSpecial") {
            setSpecialLabel(defaultSpecialLabel);
        }
        else {
            setSpecialLabel("");
            setSpecialNote("");
        }
    }, [selectedAction, defaultSpecialLabel]);
    useEffect(function () {
        var _a;
        if (selectedAction === "editSpecial") {
            setEditLabel(issue.label);
            setEditNote((_a = issue.specialNote) !== null && _a !== void 0 ? _a : "");
        }
        else if (selectedAction === "editLabel") {
            setEditLabel(issue.labelCustomized ? issue.label : "");
            setEditNote("");
        }
        else {
            setEditLabel("");
            setEditNote("");
        }
    }, [selectedAction, issue.label, issue.labelCustomized, issue.specialNote]);
    useEffect(function () {
        if (selectedAction === "editMergeLabel") {
            setEditMergeLabel(issue.label);
        }
        else {
            setEditMergeLabel("");
        }
    }, [selectedAction, issue.label]);
    useEffect(function () {
        setEditIssueNumber(selectedAction === "editNumber" ? String(issue.issueNumber) : "");
    }, [selectedAction, issue.issueNumber]);
    var canEditNumber = numberEditable && !isSpecialKind(issue.kind) && !isMultiIssue;
    var canEditLabel = !isSpecialKind(issue.kind) &&
        !isMultiIssue &&
        !issue.continuedFromPreviousVolume;
    var canResetLabel = issue.labelCustomized === true && !issue.continuedFromPreviousVolume;
    var isEditNumberValid = isValidIssueNumber(editIssueNumber);
    var editedIssueNumber = isEditNumberValid
        ? Number(editIssueNumber.trim())
        : null;
    var hasNumberChange = editedIssueNumber !== null && editedIssueNumber !== issue.issueNumber;
    useEffect(function () {
        if (selectedAction !== "merge") {
            setMergeLabel("");
            return;
        }
        if (crossVolumeSelected && crossVolumeCandidate && crossVolume) {
            var earlier = nextVolumeCandidate ? issue : crossVolumeCandidate;
            var later = nextVolumeCandidate ? crossVolumeCandidate : issue;
            var earlierVolume = nextVolumeCandidate ? volume : crossVolume;
            var laterVolume = nextVolumeCandidate ? crossVolume : volume;
            setMergeLabel(formatMessage({
                id: "ui-br-legaldeposits.periodicals.issueDialog.mergeLabel.crossVolumeDefault",
            }, crossVolumeMergeLabelValues(issueGroupNumbers(earlier), earlierVolume.label, issueGroupNumbers(later), laterVolume.label)));
            return;
        }
        if (mergeTargets.length === 0) {
            setMergeLabel("");
            return;
        }
        var targetNumbers = mergeTargets
            .map(function (id) { var _a; return (_a = allIssues.find(function (i) { return i.id === id; })) === null || _a === void 0 ? void 0 : _a.issueNumber; })
            .filter(function (n) { return n !== undefined; });
        setMergeLabel(formatMessage({
            id: "ui-br-legaldeposits.periodicals.issueDialog.mergeLabel.default",
        }, mergeLabelValues(issue.issueNumber, targetNumbers, volume.label)));
    }, [
        selectedAction,
        mergeTargets,
        crossVolumeSelected,
        crossVolumeCandidate,
        nextVolumeCandidate,
        crossVolume,
        volume,
        issue,
        allIssues,
        formatMessage,
    ]);
    var invalidateAll = useCallback(function () {
        invalidateVolumeViews(queryClient);
        invalidateDepositRecordViews(queryClient);
    }, [queryClient]);
    var handleMutationError = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var fallback, httpError, data, firstError, backendCode, values, translated, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    fallback = formatMessage({
                        id: "ui-br-legaldeposits.periodicals.issue.dialog.error",
                    });
                    if (!(error !== null && typeof error === "object" && "response" in error)) return [3 /*break*/, 4];
                    httpError = error;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpError.response.clone().json()];
                case 2:
                    data = _c.sent();
                    firstError = (_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b[0];
                    backendCode = firstError === null || firstError === void 0 ? void 0 : firstError.code;
                    values = errorParameterValues(firstError === null || firstError === void 0 ? void 0 : firstError.parameters);
                    translated = backendCode
                        ? formatMessage({
                            id: "ui-br-legaldeposits.periodicals.issue.merge.error.".concat(backendCode),
                            defaultMessage: formatMessage({
                                id: "ui-br-legaldeposits.periodicals.issue.status.error.".concat(backendCode),
                                defaultMessage: formatMessage({
                                    id: "ui-br-legaldeposits.field.error.".concat(backendCode),
                                    defaultMessage: fallback,
                                }, values),
                            }, values),
                        }, values)
                        : fallback;
                    setErrorMessage(translated);
                    return [2 /*return*/];
                case 3:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 4:
                    setErrorMessage(fallback);
                    return [2 /*return*/];
            }
        });
    }); }, [formatMessage]);
    var libraryStatusMutation = useMutation(function (_a) {
        var issueId = _a.issueId, status = _a.status;
        return changeIssueLibraryStatus(kyInstance, issueId, { status: status });
    }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var perCopyMutation = useMutation(function (changes) { return __awaiter(void 0, void 0, void 0, function () {
        var _i, changes_1, change;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, changes_1 = changes;
                    _a.label = 1;
                case 1:
                    if (!(_i < changes_1.length)) return [3 /*break*/, 4];
                    change = changes_1[_i];
                    return [4 /*yield*/, changeIssueLibraryStatus(kyInstance, issue.id, {
                            status: change.status,
                            copyNumber: change.copyNumber,
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var globalUpdateMutation = useMutation(function (_a) {
        var issueId = _a.issueId, payload = _a.payload;
        return updateIssueGlobal(kyInstance, issueId, payload);
    }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var mergeMutation = useMutation(function (payload) { return mergeIssues(kyInstance, payload); }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var unmergeMutation = useMutation(function (issueId) { return unmergeIssue(kyInstance, issueId); }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var editMergeLabelMutation = useMutation(function (_a) {
        var issueId = _a.issueId, label = _a.label;
        return updateMergeLabel(kyInstance, issueId, label);
    }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var resetLabelMutation = useMutation(function (issueId) { return resetIssueLabel(kyInstance, issueId); }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var createSpecialMutation = useMutation(function (payload) {
        return createSpecialIssue(kyInstance, periodicalLibraryId, payload);
    }, {
        onSuccess: function () {
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var deleteMutation = useMutation(function (_a) {
        var id = _a.id, renumber = _a.renumber;
        return deletePeriodicalIssue(kyInstance, id, renumber);
    }, {
        onSuccess: function () {
            setDeleteConfirmOpen(false);
            invalidateAll();
            onClose();
        },
        onError: handleMutationError,
    });
    var handleConfirm = useCallback(function () {
        if (isMultiCopy) {
            var changes = copyNumbers
                .map(function (cn) {
                var _a;
                var action = copyActions[cn];
                if (!action || action === actionForStatus((_a = issue.copyStatuses) === null || _a === void 0 ? void 0 : _a[cn])) {
                    return null;
                }
                var status = LIBRARY_STATUS_BY_ACTION[action];
                return status ? { copyNumber: cn, status: status } : null;
            })
                .filter(function (c) {
                return c !== null;
            });
            if (changes.length === 0)
                return;
            perCopyMutation.mutate(changes);
            return;
        }
        if (!selectedAction)
            return;
        if (selectedAction === "delete") {
            setRenumberFollowing(false);
            setDeleteConfirmOpen(true);
            return;
        }
        var libraryStatus = isLibraryAction(selectedAction)
            ? LIBRARY_STATUS_BY_ACTION[selectedAction]
            : undefined;
        if (libraryStatus) {
            libraryStatusMutation.mutate({
                issueId: issue.id,
                status: libraryStatus,
            });
            return;
        }
        if (selectedAction === "notPublished") {
            globalUpdateMutation.mutate({
                issueId: issue.id,
                payload: { notPublished: true, notPublishedNote: note || undefined },
            });
            return;
        }
        if (selectedAction === "revertNotPublished") {
            globalUpdateMutation.mutate({
                issueId: issue.id,
                payload: { notPublished: false, notPublishedNote: "" },
            });
            return;
        }
        if (selectedAction === "merge") {
            if (crossVolumeSelected && crossVolumeCandidate) {
                mergeMutation.mutate({
                    primaryIssueId: nextVolumeCandidate
                        ? issue.id
                        : crossVolumeCandidate.id,
                    memberIssueIds: [
                        nextVolumeCandidate ? crossVolumeCandidate.id : issue.id,
                    ],
                    label: mergeLabel.trim() || undefined,
                });
                return;
            }
            var allCandidates = __spreadArray([
                issue
            ], allIssues.filter(function (i) { return mergeTargets.includes(i.id); }), true);
            var sorted = __spreadArray([], allCandidates, true).sort(function (a, b) { return a.issueNumber - b.issueNumber; });
            var primaryId_1 = sorted[0].id;
            var memberIds = __spreadArray([issue.id], mergeTargets, true).filter(function (id) { return id !== primaryId_1; });
            mergeMutation.mutate({
                primaryIssueId: primaryId_1,
                memberIssueIds: memberIds,
                label: mergeLabel.trim() || undefined,
            });
            return;
        }
        if (selectedAction === "unmerge") {
            unmergeMutation.mutate(issue.id);
            return;
        }
        if (selectedAction === "editMergeLabel") {
            var trimmed = editMergeLabel.trim();
            if (!trimmed || trimmed === issue.label)
                return;
            editMergeLabelMutation.mutate({ issueId: issue.id, label: trimmed });
            return;
        }
        if (selectedAction === "editLabel") {
            var trimmedLabel = editLabel.trim();
            if (!trimmedLabel || trimmedLabel === issue.label)
                return;
            globalUpdateMutation.mutate({
                issueId: issue.id,
                payload: { label: trimmedLabel },
            });
            return;
        }
        if (selectedAction === "resetLabel") {
            resetLabelMutation.mutate(issue.id);
            return;
        }
        if (selectedAction === "addSpecial") {
            var trimmedLabel = specialLabel.trim();
            if (!trimmedLabel)
                return;
            createSpecialMutation.mutate({
                label: trimmedLabel,
                specialNote: specialNote.trim() || undefined,
                parentIssueId: issue.id,
            });
            return;
        }
        if (selectedAction === "editNumber") {
            if (editedIssueNumber === null || !hasNumberChange)
                return;
            globalUpdateMutation.mutate({
                issueId: issue.id,
                payload: { issueNumber: editedIssueNumber },
            });
            return;
        }
        if (selectedAction === "editSpecial") {
            var trimmedLabel = editLabel.trim();
            if (!trimmedLabel)
                return;
            globalUpdateMutation.mutate({
                issueId: issue.id,
                payload: {
                    label: trimmedLabel,
                    specialNote: editNote.trim(),
                },
            });
        }
    }, [
        selectedAction,
        issue,
        allIssues,
        note,
        mergeTargets,
        crossVolumeSelected,
        crossVolumeCandidate,
        nextVolumeCandidate,
        mergeLabel,
        specialLabel,
        specialNote,
        editedIssueNumber,
        hasNumberChange,
        editLabel,
        editNote,
        editMergeLabel,
        isMultiCopy,
        copyNumbers,
        copyActions,
        perCopyMutation,
        libraryStatusMutation,
        globalUpdateMutation,
        mergeMutation,
        unmergeMutation,
        editMergeLabelMutation,
        resetLabelMutation,
        createSpecialMutation,
    ]);
    var handleCopyActionChange = useCallback(function (copyNumber, action) { return function () {
        return setCopyActions(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[copyNumber] = action, _a)));
        });
    }; }, []);
    var handleReceiveBoth = useCallback(function () {
        var next = {};
        copyNumbers.forEach(function (cn) {
            var _a;
            if (canReceive((_a = issue.copyStatuses) === null || _a === void 0 ? void 0 : _a[cn])) {
                next[cn] = "received";
            }
        });
        setCopyActions(next);
    }, [copyNumbers, issue.copyStatuses]);
    var toggleHistory = useCallback(function (recordId) { return function () {
        return setExpandedHistory(function (prev) {
            var next = new Set(prev);
            if (next.has(recordId)) {
                next.delete(recordId);
            }
            else {
                next.add(recordId);
            }
            return next;
        });
    }; }, []);
    var handleActionChange = useCallback(function (action) { return function () { return setSelectedAction(action); }; }, []);
    var handleNoteChange = useCallback(function (e) { return setNote(e.target.value); }, []);
    var handleMergeTargetChange = useCallback(function (id) {
        setCrossVolumeSelected(false);
        setMergeTargets(function (prev) {
            return prev.includes(id) ? prev.filter(function (x) { return x !== id; }) : __spreadArray(__spreadArray([], prev, true), [id], false);
        });
    }, []);
    var handleCrossVolumeTargetChange = useCallback(function () {
        setMergeTargets([]);
        setCrossVolumeSelected(function (prev) { return !prev; });
    }, []);
    var handleMergeLabelChange = useCallback(function (e) { return setMergeLabel(e.target.value); }, []);
    var handleSpecialLabelChange = useCallback(function (e) { return setSpecialLabel(e.target.value); }, []);
    var handleSpecialNoteChange = useCallback(function (e) {
        return setSpecialNote(e.target.value);
    }, []);
    var handleEditLabelChange = useCallback(function (e) { return setEditLabel(e.target.value); }, []);
    var handleEditNoteChange = useCallback(function (e) { return setEditNote(e.target.value); }, []);
    var handleEditMergeLabelChange = useCallback(function (e) {
        return setEditMergeLabel(e.target.value);
    }, []);
    var handleEditIssueNumberChange = useCallback(function (e) {
        return setEditIssueNumber(e.target.value);
    }, []);
    var isSubmitting = libraryStatusMutation.isLoading ||
        perCopyMutation.isLoading ||
        globalUpdateMutation.isLoading ||
        mergeMutation.isLoading ||
        unmergeMutation.isLoading ||
        editMergeLabelMutation.isLoading ||
        resetLabelMutation.isLoading ||
        createSpecialMutation.isLoading ||
        deleteMutation.isLoading;
    var canDelete = issue.deletable === true;
    var handleDeleteCancel = useCallback(function () {
        setDeleteConfirmOpen(false);
    }, []);
    var handleDeleteConfirm = useCallback(function () {
        deleteMutation.mutate({ id: issue.id, renumber: renumberFollowing });
    }, [deleteMutation, issue.id, renumberFollowing]);
    var handleRenumberChange = useCallback(function (renumber) { return function () { return setRenumberFollowing(renumber); }; }, []);
    return (React.createElement(Modal, { open: true, label: formatMessage({
            id: mode === "definition"
                ? "ui-br-legaldeposits.periodicals.issue.dialog.title.definition"
                : "ui-br-legaldeposits.periodicals.issue.dialog.title.library",
        }), onClose: onClose, dismissible: true, footer: React.createElement("div", null,
            !statusReadOnly && (React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: isSubmitting ||
                    (isMultiCopy
                        ? !hasCopyAction
                        : !selectedAction ||
                            (mode === "library" &&
                                selectedAction === libraryCurrentAction) ||
                            (selectedAction === "merge" &&
                                ((mergeTargets.length === 0 && !crossVolumeSelected) ||
                                    !mergeLabel.trim())) ||
                            (selectedAction === "addSpecial" && !specialLabel.trim()) ||
                            (selectedAction === "editSpecial" && !editLabel.trim()) ||
                            (selectedAction === "editLabel" &&
                                (!editLabel.trim() ||
                                    editLabel.trim() === issue.label)) ||
                            (selectedAction === "editNumber" && !hasNumberChange) ||
                            (selectedAction === "editMergeLabel" &&
                                (!editMergeLabel.trim() ||
                                    editMergeLabel.trim() === issue.label))) },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.confirm" }))),
            React.createElement(Button, { onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement("p", { className: css.issueHeading },
            React.createElement("strong", null, issueHeading)),
        statusReadOnly && (React.createElement(MessageBanner, { type: "default", "data-test-id": "issue-status-read-only" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.readOnly.issue" }))),
        mode === "library" && !isMultiCopy && (React.createElement(React.Fragment, null, issue.libraryStatus == null ? (React.createElement(MessageBanner, { type: "default" },
            React.createElement(FormattedMessage, { id: noRecordMessageId }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css.statusLine },
                React.createElement("span", { className: css.statusLineLabel },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.current-status" })),
                React.createElement(DepositRecordStatusBadge, { status: issue.libraryStatus })),
            statusReadOnly ? null : libraryCurrentAction ? (React.createElement(LibraryStatusChoice, { currentStatus: issue.libraryStatus, selected: selectedAction && isLibraryAction(selectedAction)
                    ? selectedAction
                    : null, onSelect: handleActionChange })) : (React.createElement(MessageBanner, { type: "default" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.no-actions-available" }))),
            issue.depositRecordId && (React.createElement(CopyHistory, { recordId: issue.depositRecordId, expanded: expandedHistory.has(issue.depositRecordId), onToggle: toggleHistory })))))),
        mode === "library" && isMultiCopy && (React.createElement("div", { className: css.copySection },
            !statusReadOnly && (React.createElement(Button, { onClick: handleReceiveBoth, disabled: isSubmitting },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.receive-both" }))),
            copyNumbers.map(function (cn) {
                var _a, _b, _c;
                var status = (_a = issue.copyStatuses) === null || _a === void 0 ? void 0 : _a[cn];
                var recordId = (_b = issue.copyRecordIds) === null || _b === void 0 ? void 0 : _b[cn];
                if (!status)
                    return null;
                return (React.createElement("div", { key: cn, className: css.copyBlock },
                    React.createElement("div", { className: css.copyHeading },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.copy-label", values: { n: cn } }),
                        "  ",
                        React.createElement(DepositRecordStatusBadge, { status: status })),
                    statusReadOnly ? null : actionForStatus(status) ? (React.createElement(LibraryStatusChoice, { currentStatus: status, selected: (_c = copyActions[cn]) !== null && _c !== void 0 ? _c : null, onSelect: function (action) { return handleCopyActionChange(cn, action); }, radioName: "copy-".concat(cn) })) : (React.createElement(MessageBanner, { type: "default" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.no-actions-available" }))),
                    recordId && (React.createElement(CopyHistory, { recordId: recordId, expanded: expandedHistory.has(recordId), onToggle: toggleHistory }))));
            }))),
        mode === "library" && !issue.continuedFromPreviousVolume && (React.createElement(IssueAgendaSection, { issueId: issue.id, issueLabel: issue.label })),
        mode === "definition" && (React.createElement(React.Fragment, null,
            !issue.notPublished && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.not-published",
                }), checked: selectedAction === "notPublished", onChange: handleActionChange("notPublished") })),
            issue.notPublished && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.revert-not-published",
                }), checked: selectedAction === "revertNotPublished", onChange: handleActionChange("revertNotPublished") })),
            (eligibleForMerge.length > 0 || crossVolumeCandidate) && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.merge",
                }), checked: selectedAction === "merge", onChange: handleActionChange("merge") })),
            isMultiIssue && (React.createElement(RadioButton, { label: "".concat(formatMessage({ id: "ui-br-legaldeposits.periodicals.issue.dialog.unmerge" }), " (").concat((_e = issue.mergedIssueNumbers) === null || _e === void 0 ? void 0 : _e.join(", "), ")"), checked: selectedAction === "unmerge", onChange: handleActionChange("unmerge") })),
            isMultiIssue && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-merge-label",
                    defaultMessage: "Změnit název spojeného čísla",
                }), checked: selectedAction === "editMergeLabel", onChange: handleActionChange("editMergeLabel") })),
            canEditLabel && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-label",
                }), checked: selectedAction === "editLabel", onChange: handleActionChange("editLabel"), "data-testid": "issue-action-edit-label" })),
            canResetLabel && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.reset-label",
                }, { systemLabel: (_f = issue.systemLabel) !== null && _f !== void 0 ? _f : "" }), checked: selectedAction === "resetLabel", onChange: handleActionChange("resetLabel"), "data-testid": "issue-action-reset-label" })),
            !isSpecialKind(issue.kind) && !issue.notPublished && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.add-special",
                }), checked: selectedAction === "addSpecial", onChange: handleActionChange("addSpecial") })),
            isSpecialKind(issue.kind) && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-special",
                }), checked: selectedAction === "editSpecial", onChange: handleActionChange("editSpecial") })),
            canEditNumber && (React.createElement(RadioButton, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-number",
                }), checked: selectedAction === "editNumber", onChange: handleActionChange("editNumber") })),
            canDelete && (React.createElement(RadioButton, { label: formatMessage({
                    id: isSpecialKind(issue.kind)
                        ? "ui-br-legaldeposits.periodicals.issue.dialog.delete-special"
                        : "ui-br-legaldeposits.periodicals.issue.dialog.delete-issue",
                }), checked: selectedAction === "delete", onChange: handleActionChange("delete") })),
            !canDelete && issue.deleteBlockedReason && (React.createElement("p", { className: css.deleteBlockedHint }, formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.delete-blocked.".concat(issue.deleteBlockedReason),
                defaultMessage: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.issue.dialog.delete-blocked",
                }),
            }))))),
        (selectedAction === "notPublished" ||
            selectedAction === "merge" ||
            selectedAction === "addSpecial" ||
            selectedAction === "editSpecial" ||
            selectedAction === "editLabel" ||
            selectedAction === "editNumber" ||
            selectedAction === "editMergeLabel") && (React.createElement("hr", { className: css.actionDivider })),
        selectedAction === "editNumber" && (React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(TextField, { label: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.issue.dialog.issue-number",
                    }), value: editIssueNumber, onChange: handleEditIssueNumberChange, error: isEditNumberValid
                        ? undefined
                        : formatMessage({
                            id: "ui-br-legaldeposits.periodicals.issue.dialog.issue-number.error",
                        }, { max: MAX_ISSUE_NUMBER }), required: true })),
            React.createElement(Col, { xs: 8 },
                React.createElement(KeyValue, { label: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.issue.dialog.volume",
                    }), value: volume.label })))),
        selectedAction === "notPublished" && (React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.note",
            }), value: note, onChange: handleNoteChange })),
        selectedAction === "merge" && (React.createElement("div", { className: css.mergePicker },
            React.createElement("div", { className: css.mergeListHeading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.heading", defaultMessage: "Ozna\u010Dit \u010D\u00EDsla ke spojen\u00ED" })),
            prevVolumeCandidate && neighbourVolumes.previous && (React.createElement("div", { className: css.mergeRow },
                React.createElement(Checkbox, { label: prevVolumeCandidate.label, checked: crossVolumeSelected, onChange: handleCrossVolumeTargetChange }),
                React.createElement("span", { className: css.crossVolumeBadge },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.cross-volume-badge", values: { volume: neighbourVolumes.previous.label } })),
                React.createElement("span", { className: css.mergeRowDate }, formatIssueDate(prevVolumeCandidate.expectedDate)))),
            __spreadArray(__spreadArray([], eligibleForMerge, true), [issue], false).sort(function (a, b) { return a.issueNumber - b.issueNumber; })
                .map(function (row) {
                return row.id === issue.id ? (React.createElement("div", { key: row.id, className: css.anchorRow },
                    React.createElement("span", { className: css.anchorMarker }, "\u25B8"),
                    React.createElement("span", { className: css.anchorLabel }, row.label),
                    React.createElement("span", { className: css.anchorBadge },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.current-issue-hint", defaultMessage: "Toto \u010D\u00EDslo" })),
                    React.createElement("span", { className: css.anchorDate }, formatIssueDate(row.expectedDate)))) : (React.createElement("div", { key: row.id, className: css.mergeRow },
                    React.createElement(Checkbox, { label: row.label, checked: mergeTargets.includes(row.id), onChange: function () { return handleMergeTargetChange(row.id); } }),
                    React.createElement("span", { className: css.mergeRowDate }, formatIssueDate(row.expectedDate))));
            }),
            nextVolumeCandidate && neighbourVolumes.next && (React.createElement("div", { className: css.mergeRow },
                React.createElement(Checkbox, { label: nextVolumeCandidate.label, checked: crossVolumeSelected, onChange: handleCrossVolumeTargetChange }),
                React.createElement("span", { className: css.crossVolumeBadge },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.cross-volume-badge", values: { volume: neighbourVolumes.next.label } })),
                React.createElement("span", { className: css.mergeRowDate }, formatIssueDate(nextVolumeCandidate.expectedDate)))),
            crossVolumeCandidate && (React.createElement("div", { className: css.hint },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.cross-volume-hint" }))),
            React.createElement("div", { className: css.mergeLabelField },
                React.createElement(TextField, { label: formatMessage({
                        id: "ui-br-legaldeposits.periodicals.issue.dialog.merge.label",
                    }), value: mergeLabel, onChange: handleMergeLabelChange, maxLength: ISSUE_LABEL_MAX_LENGTH })))),
        selectedAction === "addSpecial" && (React.createElement(React.Fragment, null,
            React.createElement(TextField, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.special-issue.label",
                }), value: specialLabel, onChange: handleSpecialLabelChange, maxLength: ISSUE_LABEL_MAX_LENGTH, required: true }),
            React.createElement(TextArea, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.special-issue.note",
                }), value: specialNote, onChange: handleSpecialNoteChange }))),
        selectedAction === "editMergeLabel" && (React.createElement(TextField, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-merge-label.input",
                defaultMessage: "Název spojeného čísla",
            }), value: editMergeLabel, onChange: handleEditMergeLabelChange, maxLength: ISSUE_LABEL_MAX_LENGTH, required: true, "data-testid": "edit-merge-label-input" })),
        selectedAction === "editLabel" && (React.createElement(TextField, { label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.issue.dialog.edit-label.input",
            }), value: editLabel, onChange: handleEditLabelChange, maxLength: ISSUE_LABEL_MAX_LENGTH, required: true, "data-testid": "edit-issue-label-input" })),
        selectedAction === "editSpecial" && (React.createElement(React.Fragment, null,
            React.createElement(TextField, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.special-issue.label",
                }), value: editLabel, onChange: handleEditLabelChange, maxLength: ISSUE_LABEL_MAX_LENGTH, required: true }),
            React.createElement(TextArea, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicals.special-issue.note",
                }), value: editNote, onChange: handleEditNoteChange }))),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage)),
        deleteConfirmOpen && (React.createElement(ConfirmationModal, { open: true, 
            // the message carries the renumber radios, which must not sit inside the default <p>
            bodyTag: "div", heading: formatMessage({
                id: isSpecialKind(issue.kind)
                    ? "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.heading"
                    : "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.heading-issue",
            }), message: React.createElement(React.Fragment, null,
                formatMessage({
                    id: isSpecialKind(issue.kind)
                        ? "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.body"
                        : "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.body-issue",
                }, { label: issue.label }),
                !isSpecialKind(issue.kind) && (React.createElement("div", { className: css.renumberChoice },
                    React.createElement(RadioButton, { name: "deleteRenumberMode", checked: !renumberFollowing, onChange: handleRenumberChange(false), label: formatMessage({
                            id: "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.keep-gap",
                        }) }),
                    React.createElement(RadioButton, { name: "deleteRenumberMode", checked: renumberFollowing, onChange: handleRenumberChange(true), label: formatMessage({
                            id: "ui-br-legaldeposits.periodicals.issue.dialog.delete-confirm.renumber",
                        }) })))), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.button.delete",
            }), cancelLabel: formatMessage({
                id: "ui-br-legaldeposits.button.cancel",
            }), onConfirm: handleDeleteConfirm, onCancel: handleDeleteCancel }))));
};
